import _Vue from 'vue';
import * as dateFns from 'date-fns';
import BigNumber from 'bignumber.js';

export const numberToBMK = (
  num: string | number | BigNumber,
  decimal: number = 2
): string => {
  const str = typeof num === 'string' ? num : num.toFixed(decimal).toString();
  const short = ['', 'K', 'M', 'B'];
  let unit = 0;
  let last = str.length;
  if (last < 4 || str.indexOf('.') !== -1) {
    return str;
  }
  while (last >= 4 && unit <= 3) {
    last -= 3;
    unit += 1;
  }
  const before = str.slice(0, last);
  const after = str.slice(last, last + decimal);
  return before + '.' + after + short[unit];
};

export const commaForDigits = (digits: string | number | BigNumber): string => {
  if (typeof digits !== 'string') {
    digits = digits.toString();
  }
  const parts = digits.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

export const amountFixed = (
  amount: string | number | BigNumber,
  digits: number = 2
) => {
  amount = new BigNumber(amount);
  if (amount.isEqualTo(0)) {
    return 0;
  }
  return amount.toFixed(digits);
};

export const usdFixed = (amount: string | number | BigNumber) => {
  amount = new BigNumber(amount);
  if (amount.isEqualTo(0)) {
    return 0;
  }
  if (amount.isGreaterThan(1)) {
    return amount.toFixed(2);
  } else {
    return amount.toFixed(4);
  }
};

export const digitFixed = (
  digits: string | number | BigNumber,
  len: number = 2
) => {
  if (typeof digits === 'string') {
    digits = new BigNumber(digits);
  }
  let res = digits.toFixed(len);
  if (res.indexOf('.') !== -1) {
    while (res.length > 0) {
      if (res[res.length - 1] === '.') {
        res = res.substr(0, res.length - 1);
        break;
      }
      if (res[res.length - 1] === '0') {
        res = res.substr(0, res.length - 1);
      } else {
        break;
      }
    }
  }
  return res;
};

export const formatTime = (ts: number, format: string): string => {
  return dateFns.format(ts, format);
};

export const formatCountdown = (
  ts: number,
  h: number,
  m: number,
  s: number
): string => {
  if (h !== 0) {
    return `${h}hr ${m}min ${s}sec`;
  } else if (m !== 0) {
    return `${m}min ${s}sec`;
  } else {
    return `${s}sec`;
  }
};

export const formatTrait = (str: string): string => {
  try {
    if (str) {
      return str.replaceAll('_', ' ');
    } else {
      return str;
    }
  } catch {
    return str;
  }
};

export const alpaUnit = (amount: BigNumber | number | string) => {
  return new BigNumber(`${amount}e-18`);
};

export const fixedAndComma = (
  amount: BigNumber | number | string,
  len: number
) => {
  return commaForDigits(digitFixed(amount, 2));
};

export const FilterPlugin = (Vue: typeof _Vue) => {
  Vue.filter('numberToBMK', numberToBMK);
  Vue.filter('commaForDigits', commaForDigits);
  Vue.filter('digitFixed', digitFixed);
  Vue.filter('formatTime', formatTime);
  Vue.filter('formatCountdown', formatCountdown);
  Vue.filter('formatTrait', formatTrait);
  Vue.filter('alpaUnit', alpaUnit);
  Vue.filter('fixedAndComma', fixedAndComma);
  Vue.filter('usdFixed', usdFixed);
  Vue.filter('amountFixed', amountFixed);
};
